import React from "react";
import "./Download.css";
import DownloadOnAppStore from "../Buttons/DownloadOnAppStore";
import DownloadOnGooglePlay from "../Buttons/DownloadOnGooglePlay";
import DownloadOnAppStoreMobile from "../Buttons/DownloadOnAppStoreMobile";
import DownloadOnGooglePlayMobile from "../Buttons/DownloadOnGooglePlayMobile";

const Download = () => {
  return (
    <div className="download-container">
      <div className="download-details">
        <h4>Download Sportrex Gamers Wallet and earn free SPT Token.</h4>
        <div className="download-buttons">
          <DownloadOnAppStore />
          <DownloadOnGooglePlay />
          <DownloadOnAppStoreMobile />
          <DownloadOnGooglePlayMobile />
        </div>
      </div>
    </div>
  );
};

export default Download;
